
import { delete_, get } from "@/features/schemas/services/schemaApi";
import api from "@/services/api";

export default {
    downloadFile,
    deleteFile
};

export async function downloadFile(fileId, alternateSource) {
    let source = alternateSource
        ? alternateSource + fileId
        : `/api/Files/Download/${fileId}`

    let response = await api.get(source, { responseType: 'blob' })
    let blob = new Blob([response.data], { type: response.headers["content-type"] });
    let downloadUrl = window.URL.createObjectURL(blob);
    let link = document.createElement("a");

    if (typeof link.download === "undefined") {
        window.location.href = downloadUrl;
        return;
    }

    link.href = downloadUrl;
    let fileName = getFileName(response.headers['content-disposition']) ?? "file";
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
}

export async function uploadFile(fileToUpload, followLocation = false) {
    if(!fileToUpload) {
        return;
    }
    let formData = new FormData();
    formData.append("file", fileToUpload);

    const response = (await fetch("/api/files", {
        method: "POST",
        body: formData
    }))
    const fileId = await response.json()
    if (!followLocation) {
        return fileId
    }
    return await get("file", null, fileId)
}

export async function uploadImage(imageToUpload, endpoint = "/api/Images") {
    if (!imageToUpload) {
        return;
    }
    const formData = new FormData();
    formData.append("file", imageToUpload);

    const response = await fetch(endpoint, {
        method: "POST",
        body: formData
    });
    if (!response.ok) {
        throw new Error("The image could not be uploaded.");
    }
    return await response.json();
}

function getFileName(disposition) {
    const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-.]+)(?:; ?|$)/i;

    if (utf8FilenameRegex.test(disposition)) {
        return decodeURIComponent(utf8FilenameRegex.exec(disposition)[1]);
    }

    // prevent ReDos attacks by anchoring the ascii regex to string start and
    // slicing off everything before 'filename='
    const filenameStart = disposition
        .toLowerCase()
        .indexOf('filename=');

    if (filenameStart < 0) {
        return null;
    }

    const asciiFilenameRegex = /^filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;
    const partialDisposition = disposition.slice(filenameStart);
    const matches = asciiFilenameRegex.exec(partialDisposition);

    return matches && matches[2] ?
        matches[2] :
        null;
}

export async function deleteFile(fileId, scope) {
    await delete_("file", scope, fileId);
}

export function toMegabytes(bytes) {
    return (bytes / (1024 * 1024)).toFixed(2);
}

export function truncateFileName(fileName) {
    const fileExtension = fileName.split('.').pop();
    const fileNameWithoutExtension = fileName
        .substring(0, fileName.length - fileExtension.length - 1);

    if (fileNameWithoutExtension.length <= 20) {
        return fileName;
    }

    const truncatedName = `${fileNameWithoutExtension.substring(0, 17)}...${fileExtension}`;
    return truncatedName;
}
